import { UserLoan } from '@matech/thebigpos-sdk'

export const filterUserLoansByRoles = (
	userLoans: UserLoan[],
	roles: UserLoan['role'][]
) => {
	if (!userLoans) return []
	return userLoans.filter((userLoan) => {
		const userRole = userLoan.role
		return roles.includes(userRole)
	})
}

export const truncatedUserLoans = (userLoans: UserLoan[]) => {
	const remaining = 0
	if (userLoans.length > 1) {
		return {
			userLoans: userLoans.slice(0, 1),
			remaining: userLoans.length - 1,
		}
	}

	return { userLoans, remaining }
}

export const addSpacesToPascalCase = (str: string) => {
	return str.replace(/([a-z])([A-Z])/g, '$1 $2')
}

const legacyDomains = [
	'alerus-pos.com',
	'assurance-pos.com',
	'bankoftn-pos.com',
	'ccf-pos.com',
	'corelending-pos.com',
	'dgp-pos.com',
	'fembi-pos.com',
	'finomus-pos.com',
	'gateless-pos.com',
	'haf-pos.com',
	'hf-pos.com',
	'hmcapply.com',
	'khov-pos.com',
	'loansteady-pos.com',
	'localbank.mortgage',
	'luminate-pos.com',
	'mat-ch.info',
	'mercbank-pos.com',
	'michiganfirstmortgagemate.com',
	'mission-pos.com',
	'mlp-pos.com',
	'mvloans.com',
	'nationwide-pos.com',
	'newstory-pos.com',
	'njl-pos.com',
	'northpoint-pos.com',
	'nrl-pos.com',
	'orion-pos.com',
	'pacor-pos.com',
	'trad-pos.com',
	'ulstersavings-mortgage.com',
	'vcap-pos.com',
]

export const getApiHost = (domain: string) => {
	if (legacyDomains.includes(domain)) {
		return 'https://shared.thebigpos-api.com'
	}
	return (
		process.env.REACT_APP_POS_API_HOST ?? 'https://api.thebigpos.com'
	)
}
